<template>
    <div>
        <navigation :brand="$route.query.brandName" :model="$route.query.model"
                    :capacity="$route.query.capacity"></navigation>
        <modal v-if="showModal" @close="showModal = false">
            <!--
              you can use custom tooltip here to overwrite
              default tooltip
            -->
            <h3 slot="header" style="font-weight: bold">{{questions.title}}</h3>
            <h3 slot="body">{{questions.tooltip}}</h3>
        </modal>
        <div class="main-wrapper">
            <div class="row">
                <div class="col-lg-4 col-md-12">
                    <div class="phone-img-wrapper">
                        <img class="phone-img" :src="prices.img" alt="">
                        <p class="brand-name">{{$route.query.brandName}}</p>
                        <p class="model">{{$route.query.model}}</p>
                        <div v-if="calculated" ref="priceWrapper" class="price-wrapper">
                            <p style="font-weight: bold">Procenjena vrednost</p>
                            <div class="price-box">
                                <p class="final-price">{{finalPrice}} RSD</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-md-12">
                    <ul>
                        <transition name="fade">
                            <li v-if="!allQuestionsAnswered" class="questions-alert">
                                <div class="row">
                                    <p>Molimo Vas da popunite sve odgovore.</p>
                                </div>
                            </li>
                        </transition>
                        <li v-for="(question,i) in $root.$data.questionsList" v-if="!question.variation">
                            <div class="row">
                                <div class="col-lg-1 col-xs-2">
                                    <div class="question-icon">
                                        <img :src="question.img" alt="">
                                    </div>
                                </div>
                                <div class="col-lg-11 col-xs-10 description">
                                    <div class="row">
                                        <h3>{{question.title}}</h3>
                                        <span class="tooltip" @click="fillToolTip(i)"
                                              data-tooltip="The device should power on and be fully working, free from any faults.">?</span>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-9 col-sm-12">
                                            <p>{{question.subtitle}}</p>
                                        </div>
                                        <div class="col-lg-3 col-sm-12">
                                            <div class="radio-wrapper">
                                                <label class="label" :for="question.id1">
                                                    <input class="option-input radio" type="radio" :id="question.id1"
                                                           :value=true
                                                           v-model="question.model">
                                                    <p>Da</p>
                                                </label>
                                                <label class="label" :for="question.id2">
                                                    <input class="option-input radio" type="radio" :id="question.id2"
                                                           :value=false
                                                           v-model="question.model">
                                                    <p>Ne</p>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <!--<li v-if="prices.hasNetwork">-->
                        <!--<div class="row">-->
                        <!--<div class="col-lg-1 col-xs-2">-->
                        <!--<div class="question-icon">-->
                        <!--<img src="../assets/img/network.png" alt="">-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--<div class="col-lg-11 col-xs-10 description">-->
                        <!--<div class="row">-->
                        <!--<h3>Network</h3>-->
                        <!--<span class="tooltip" @click="fillToolTip(4)" data-tooltip="Explain Network">?</span>-->
                        <!--</div>-->
                        <!--<div class="row">-->
                        <!--<div class="col-lg-10 col-sm-12">-->
                        <!--<p>Please choose network</p>-->
                        <!--</div>-->
                        <!--<div class="col-lg-2 col-sm-12">-->
                        <!--<select v-model="network">-->
                        <!--<option disabled value="">Please select one</option>-->
                        <!--<option :value="true">Unlocked</option>-->
                        <!--<option :value="false">T-mobile</option>-->
                        <!--<option :value="false">Telenor</option>-->
                        <!--</select>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</li>-->
                        <div class="get-price">
                            <div class="row">
                                <div class="col-lg-2 col-xs-6">
                                    <router-link v-if="!prices.hasNetwork"
                                                 :to="{name: 'models', query: {brandName:  $route.query.brandName}}">
                                        <button class="back-btn">Nazad</button>
                                    </router-link>
                                    <router-link v-else
                                                 :to="{name: 'category', query: {model: $route.query.model, brandName: $route.query.brandName}}">
                                        <button class="back-btn">Nazad</button>
                                    </router-link>
                                </div>
                                <div class="col-lg-8 quote">
                                    <p>Dobijena cena se bazira na datim odgovorima ali ne mora predstavljati finalnu
                                        otkupnu vrednost uređaja. Finalna cena ce biti utvrđena nakon tehničkog pregleda
                                        uređaja.</p>
                                </div>
                                <div class="col-lg-2 col-xs-6 get-price-wrapper">
                                    <button v-scroll-to="'.phone-img-wrapper'" class="get-price-btn"
                                            @click="calculateFinalPrice">Saznaj cenu
                                    </button>
                                </div>
                                <div class="col-xs-12 quote-res">
                                    <p>Dobijena cena se bazira na datim odgovorima ali ne mora predstavljati finalnu
                                        otkupnu vrednost uređaja. Finalna cena ce biti utvrđena nakon tehničkog pregleda
                                        uređaja.</p>
                                </div>
                            </div>
                        </div>
                    </ul>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import Navigation from './Navigation'
    import Modal from "./Modal";

    export default {
        components: {
            Modal,
            Navigation
        },
        name: 'phone-details',
        data() {
            return {
                prices: {},
                finalPrice: 0,
                calculated: false,
                allQuestionsAnswered: true,
                isMinPrice: true,
                minMaxMode: true, // TOGGLE FOR MIN MAX PRICES ONLY,
                showModal: false,
                questions: {},
            }
        },

        destroyed() {
            for (var property in this.$root.$data.questionsList) {
                if (this.$root.$data.questionsList.hasOwnProperty(property)) {
                    this.$root.$data.questionsList[property].model = null;

                }
            }
        },
        created() {
            let brand;
            brand = this.$root.$data.phonesObject[this.$route.query.brandName];
            let memory = this.hasMemmory(brand);
            this.getPrices(brand, memory);
            this.finalPrice = this.prices.maxPrice;
            if (!this.prices.hasNetwork) {
                this.$root.$data.questionsList["network"].model = true
            }
        },
        methods: {
            hasMemmory(brand) {
                if (brand.memmoryModels) {
                    return true
                } else {
                    return false
                }
            },
            getPrices(brand, memory) {
                if (memory) {
                    brand.models.forEach((el) => {
                        this.loopMemories(el.memmories)
                    })
                } else {
                    brand.models.forEach((el) => {
                        if (el.name === this.$route.query.model) {
                            this.prices = el
                        }
                    })
                }
            },
            loopMemories(memory) {
                memory.forEach((el) => {
                    if (el.capacity === this.$route.query.capacity) {
                        this.prices = el
                    }
                })
            },
            calculateFinalPrice() {

                if (this.checkEmptyFields() === false) {
                    return
                }

                if (this.minMaxMode) {
                    this.minMax()
                } else {
                    this.allPrices()
                }

                this.calculated = true
            },
            minMax() {

                if (!this.$root.$data.questionsList["functional"].model || !this.$root.$data.questionsList["liquid"].model) { // FUNKCIONALNOST I DISPLAY DAJU 0 DINARA
                    this.finalPrice=0;
                } else if (!this.$root.$data.questionsList["functional"].model || !this.$root.$data.questionsList["liquid"].model
                    || !this.$root.$data.questionsList["network"].model || !this.$root.$data.questionsList["cover"].model ||
                    !this.$root.$data.questionsList["buttons"].model || !this.$root.$data.questionsList["display"].model) {
                    this.finalPrice = this.prices.minPrice
                    this.isMinPrice = true
                } else {
                    this.finalPrice = this.prices.maxPrice
                    this.isMinPrice = false
                }
            },
            allPrices() {
                if (!this.$root.$data.questionsList["functional"].model || !this.$root.$data.questionsList["liquid"].model || !this.network) {
                    this.finalPrice = this.prices.minPrice
                    this.isMinPrice = true
                } else if (!this.$root.$data.questionsList["cover"].model || !this.$root.$data.questionsList["buttons"].model) {
                    this.finalPrice = (this.$root.$data.questionsList["display"].model ? this.prices.maxPrice - this.prices.button : this.prices.maxPrice - this.prices.display - this.prices.button)
                    this.isMinPrice = true
                } else if (!this.$root.$data.questionsList["display"].model) {
                    this.finalPrice = this.prices.maxPrice - this.prices.display
                    this.isMinPrice = true
                } else {
                    this.finalPrice = this.prices.maxPrice
                    this.isMinPrice = false
                }
            },
            checkEmptyFields() {


                if (this.$root.$data.questionsList["functional"].model === null || this.$root.$data.questionsList["display"].model === null || this.$root.$data.questionsList["cover"].model === null || this.$root.$data.questionsList["buttons"].model === null || this.$root.$data.questionsList["liquid"].model === null || this.$root.$data.questionsList["network"].model === null) {
                    this.allQuestionsAnswered = false
                    return false
                } else {
                    this.allQuestionsAnswered = true
                }
            },

            fillToolTip(i) {
                this.showModal = true;
                this.questions = this.$root.$data.questionsList[i]
            },


        }
    }
</script>

<style scoped>

    ul {
        list-style: none;
    }

    ul li {
        margin: 1rem 0;
        padding: 0.6rem;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1);
    }

    img {
        max-width: 100%;
    }

    .phone-img {
        max-width: 80%;
    }

    .price-wrapper {
        text-align: center;
        padding: 0 3.5rem;
    }

    .questions-alert {
        box-shadow: none;
        background: #f2dede;
        color: #a94442;
    }

    .phone-img-wrapper {
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1);
        margin: 1rem 2rem 0 0;
        padding: 1rem 0;
        text-align: center;
    }

    .brand-name {
        text-transform: capitalize;
        font-size: 1.3rem;
        margin: 0.3rem;
        font-weight: bold;
    }

    .model {
        font-size: 1.1rem;
        margin-bottom: 2rem;
    }

    .price-box {
        margin: 0.5rem 0 0.5rem 0;
        padding: 1rem 2rem;
        background: #FFf;
        font-size: 1.5rem;
        font-weight: bold;
        color: #0061b1;
        border: 2px #0061b1 solid;
    }

    .price-box-min {
        background: #F05D5E;
        border: solid 2px #BE1E2D;
        color: #fff;
    }

    .description {
        /*padding-left: 0.8rem;*/
    }

    .question-icon img {
    }

    .description h3 {
        font-size: 1.2rem;
        margin-bottom: 0.3rem;
        font-weight: 500;
        display: inline-block;
    }

    .description p {
        font-size: 0.9rem;
    }

    .tooltip {
        text-align: center;
        /*color: #008bb1;*/
        border: 2px solid #008bb1;
        float: right;
        font-size: 0.7rem;
        font-weight: bold;
        width: 15px;
        height: 15px;
        cursor: pointer;
        float: right;
    }

    select {
        width: 100%;
    }

    .get-price {
        margin-top: 2rem;
    }

    .get-price p {
        margin-top: 0.5rem;
        font-size: 0.7rem;
        text-align: center;
    }

    .quote-res {
        display: none;
    }

    .back-btn {
        border: 1px solid #000;
        background: white;
        color: #000;
        padding: 0.5rem 1.4rem;
        cursor: pointer;
        font-size: 1rem;
        border-radius: 4px;
    }

    .back-btn:hover {
        color: white;
    }

    .back-btn:hover {
        background: #000;
    }

    .get-price-wrapper {
        text-align: right;
    }

    .get-price-btn {
        border: 1px solid #0061b1;
        border-radius: 4px;
        background: white;
        color: #0061b1;
        padding: 0.5rem 0.4rem;
        cursor: pointer;
        font-size: 1rem;
    }

    .get-price-btn:hover {
        color: white;
        background: #0061b1;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    /* ToolTip */

    /* RADIO BUTTON */

    @keyframes click-wave {
        0% {
            height: 40px;
            width: 40px;
            opacity: 0.35;
            position: relative;
        }
        100% {
            height: 200px;
            width: 200px;
            margin-left: -80px;
            margin-top: -80px;
            opacity: 0;
        }
    }

    .option-input {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        -o-appearance: none;
        appearance: none;
        position: relative;
        height: 15px;
        width: 15px;
        /*transition: all 0.15s ease-out 0s;*/
        background: #cbd1d8;
        border: none;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        outline: none;
        z-index: 2;
        margin: 0 0 0 0.7rem;
    }

    .option-input:hover {
        background: #9faab7;
    }

    .option-input:checked {
        background: #0061b1;
    }

    /* for edge and explorer */

    .option-input::-ms-check {
        background: #0061b1;
        color: #fff;
        border-color: #0061b1;
    }

    /*------*/

    .option-input:checked::before {
        height: 15px;
        width: 15px;
        position: absolute;
        content: '✔';
        display: inline-block;
        font-size: 10px;
        text-align: center;
        line-height: 15px;
        color: #fff;
    }

    /*.option-input:checked::after {*/
    /*!*-webkit-animation: click-wave 0.65s;*!*/
    /*!*-moz-animation: click-wave 0.65s;*!*/
    /*!*animation: click-wave 0.65s;*!*/
    /*tooltip: '';*/
    /*display: block;*/
    /*position: relative;*/
    /*z-index: 100;*/
    /*}*/

    .option-input.radio {
    }

    .option-input.radio::after {
        border-radius: 50%;
    }

    .radio-wrapper {
        position: relative;
        text-align: right;
    }

    .label p {
        display: inline-block;
        margin: 0 0.5rem 0 0.3rem;
    }

    .label p:last-child {
        margin-right: 0;
    }

    /* RESPONSIVE */

    @media only screen and (max-width: 768px) {
        [data-tooltip]:before {
            margin-left: -168px;
        }

        .phone-img-wrapper {
            margin: 0;
        }

        .description {
            padding-left: 0.6rem;
        }

        .description h3 {
            font-size: 1rem;
        }

        .description p {
            font-size: 0.8rem;
        }

        .radio-wrapper {
            margin-top: 0.5rem;
        }

        select {
            margin-top: 0.2rem;
        }

        .quote {
            display: none;
        }

        .quote-res {
            display: block;
            text-align: center;
        }

        .back-btn {
            padding: 0.5rem 2rem;
        }

        .get-price-wrapper {
            text-align: right;
        }

    }

</style>
